import { Paper } from "@material-ui/core";
import PostAddRoundedIcon from "@mui/icons-material/PostAddRounded";
import Diversity3RoundedIcon from "@mui/icons-material/Diversity3Rounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import "../../../../Assets/css/Community/MyfeedInfo.css";
import { useState } from "react";
// import PostFeedModal from "./PostFeed/PostFeedModal";
import CreateEventModal from "../Events/CreateEventModal";
import CreateBlogModal from "../Blogs/CreateBlogsModal";
import CreateFeedModal from "../Feeds/CreateFeedModal";

const MyPosts = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEventModalOpen, setIsEventModalOpen] = useState(false);
  const [isBlogModalOpen, setIsBlogModalOpen] = useState(false);

  return (
    <div className="myfeed-info-container">
      <Paper className="myfeed-container">
        <div className="myfeed-section" onClick={() => setIsModalOpen(true)}>
          <PostAddRoundedIcon className="myfeed-icon" />
          <span>Create Post</span>
        </div>
        {/* <div className="myfeed-section">
          <Diversity3RoundedIcon className="myfeed-icon" />
          <span>Create Communities</span>
        </div> */}
        <div
          className="myfeed-section"
          onClick={() => setIsEventModalOpen(true)}
        >
          <CalendarMonthRoundedIcon className="myfeed-icon" />
          <span>Create Events</span>
        </div>
        {/* <div
          className="myfeed-section"
          onClick={() => setIsBlogModalOpen(true)}
        >
          <MenuBookRoundedIcon className="myfeed-icon" />
          <span>Create Blogs</span>
        </div> */}
      </Paper>

      <CreateFeedModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
        
      <CreateEventModal
        open={isEventModalOpen}
        onClose={() => setIsEventModalOpen(false)}
      />
      <CreateBlogModal
        open={isBlogModalOpen}
        onClose={() => setIsBlogModalOpen(false)} // Add new modal
      />
    </div>
  );
};

export default MyPosts;
